import SearchBar from '../../discover/components/SearchBar';

interface EventsHeroProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  totalEvents: number;
}

const EventsHero = ({ searchQuery, onSearchChange, totalEvents }: EventsHeroProps) => {
  return (
    <section className="relative pt-28 pb-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d08f3e44d7fde946846a062c4dc83a18.jpg"
          alt="Events background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-teal-900/60"></div>
      </div>

      {/* Floating decorative blobs */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-teal-500/20 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-cyan-500/20 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-teal-500/20 border border-teal-400/30 rounded-full text-teal-300 text-sm font-medium mb-6 backdrop-blur-sm">
          <i className="ri-calendar-event-line"></i>
          <span>{totalEvents} Events Available</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-5 leading-tight tracking-tight">
          Find Your Next<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-cyan-400">
            Unforgettable Event
          </span>
        </h1>
        <p className="text-lg text-white/80 max-w-2xl mx-auto mb-10">
          Explore thousands of events — from live concerts and tech conferences to local meetups and workshops.
        </p>

        {/* Search */}
        <div className="max-w-2xl mx-auto">
          <SearchBar value={searchQuery} onChange={onSearchChange} />
        </div>

        {/* Quick tags */}
        <div className="flex flex-wrap items-center justify-center gap-2 mt-6">
          {['Music', 'Technology', 'Business', 'Sports', 'Arts', 'Food & Drink', 'Online'].map((tag) => (
            <span
              key={tag}
              className="px-3 py-1 bg-white/10 hover:bg-white/20 border border-white/20 rounded-full text-white/80 text-xs font-medium cursor-pointer transition-all backdrop-blur-sm whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsHero;
